// import FullCalendar from 'vue-fullcalendar'
import {
  CalendarView,
  CalendarViewHeader,
  CalendarMathMixin
} from 'vue-simple-calendar'
import ChecklistFix from '../checklist-fix'
require('vue-simple-calendar/static/css/default.css')
require('vue-simple-calendar/static/css/holidays-us.css')

export default {
  name: 'calender-checklist',
  components: {
    CalendarView,
    CalendarViewHeader,
    ChecklistFix
  },
  mixins: [CalendarMathMixin],
  props: [],
  data () {
    return {
      displayPeriodUom: 'month',
      displayPeriodCount: 1,
      useDefaultTheme: true,
      useHolidayTheme: true,
      showDate: this.thisMonth(1),
      loading: false
    }
  },
  computed: {
    // checklist_yesterdays () {
    //   return this.$store.getters['Checklist/getChecklistYesterday']
    // },
    // checklist_todays () {
    //   return this.$store.getters['Checklist/getChecklistToday']
    // },
    // checklist_tomorrows () {
    //   return this.$store.getters['Checklist/getChecklistTomorrow']
    // },
    events () {
      console.log(this.$store.getters['Checklist/getCalendarChecklist'])
      return this.$store.getters['Checklist/getCalendarChecklistInProgress']
    },
    yesterday_date () {
      return new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10)
    },
    today_date () {
      return new Date().toISOString().substr(0, 10)
    },
    tomorrow_date () {
      return new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().substr(0, 10)
    },
    themeClasses () {
      return {
        'theme-default': this.useDefaultTheme,
        'holiday-us-traditional': this.useHolidayTheme,
        'holiday-us-official': this.useHolidayTheme
      }
    }
  },
  mounted () {
    this.$loading.start()
    this.loading = true
    Promise.all([
      this.$store.dispatch('Checklist/getListChecklist', {per_page: 'all', is_calendar: ''})
    ]).then(res => {
      console.log(res)
      // this.chk_item_fix = res[1]
      this.loading = false
      this.$loading.complete()
    }).catch(errors => {
      this.loading = false
      this.$loading.fail()
    })
  },
  methods: {
    setShowDate (d) {
      this.message = `Changing calendar view to ${d.toLocaleDateString()}`
      this.showDate = d
    },
    thisMonth (d, h, m) {
      const t = new Date()
      return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0)
    },
    onClickDay (d) {
      console.log(d)
      // this.message = `You clicked: ${d.toLocaleDateString()}`
    },
    onClickEvent (e) {
      this.$router.push('/checklist/' + e.id + '/view')
      // this.message = `You clicked: ${e.title}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/calender-checklist/calender-checklist.js